import React, { Component } from "react";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { ImportStockWisesaStates } from "./types/ImportStockWisesaTypes";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";
import { Button, Col, DatePicker, Form, Modal, Result, Row, Spin, Table, Tabs, Tooltip } from "antd";
import { FormOutlined, LeftOutlined, SaveOutlined, SearchOutlined } from "@ant-design/icons";
import WarehouseSelect from "../../components/warehouse/WarehouseSelect";
import moment from "moment";

const { TabPane } = Tabs;

export interface ImportStockWisesaProps {}

class DdmsInvoice extends Component<ImportStockWisesaProps & any, ImportStockWisesaStates> {
  private readonly initState!: ImportStockWisesaStates;
  private token = new Cookies().get("_t");
  private tableColumn: any = [
    {
      title: "Delivery Create Date",
      dataIndex: "delivery_create_date",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "DO Number",
      dataIndex: "delivery_order_number",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Debit Note Number",
      dataIndex: "debit_note_number",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Maindealer Code",
      dataIndex: "vehicle_maindealer_code",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Kode Warna",
      dataIndex: "vehicle_color_code",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nomor Rangka",
      dataIndex: "vehicle_chassis_number",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Tahun",
      dataIndex: "vehicle_year",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
  ];

  private tableResult: any = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_name",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
  ];

  constructor(props: (ImportStockWisesaProps & any) | any) {
    super(props);
    this.initState = {
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      startDate: moment().clone().format("YYYY-MM-DD"),
      endDate: moment().clone().format("YYYY-MM-DD"),
      orderMonth: moment().clone().format("YYYY-MM"),
      fetchDdms: false,
      dataDdms: [],
      countDataDdms: 0,
      tabKey: "1",
      finalLoadingModal: false,
      saveProcessing: false,
      modalConfirm: false,
      modalResult: false,
      listResult: [],
      warehouseCode: "",
      warehouseName: "",
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onchangeStartDate = (data: any) => {
    if (data) {
      this.setState({
        startDate: data,
        endDate: data,
      });
    }
  };

  onchangeOrderMonth = (data: any) => {
    if (data) {
      this.setState({
        orderMonth: data,
      });
    }
  };

  cancelProcess = async () => {
    await this.promisedSetState({
      tabKey: "1",
      dataDdms: [],
      countDataDdms: 0,
    });
  };

  fetchDataDdms = async () => {
    await this.promisedSetState({
      fetchDdms: true,
      listResult: [],
      finalLoadingModal: true,
    });

    try {
      stockOtodisService.setToken(this.token);
      await stockOtodisService
        .getStockWisesa({
          dealerCode: this.state.dealerCode,
          startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
        })
        .then(async (value) => {
          await this.promisedSetState({
            tabKey: "2",
            fetchDdms: false,
            finalLoadingModal: false,
            dataDdms: value.data.data,
            countDataDdms: value.data.total_data,
          });
        });
    } catch (e) {
      await this.promisedSetState({
        tabKey: "1",
        fetchDdms: false,
        finalLoadingModal: false,
        dataDdms: [],
        countDataDdms: 0,
      });
      Modal.error({
        title: "Proses Gagal",
        content: "" + e,
      });
    }
  };

  onSaveData = async () => {
    this.setState({
      modalConfirm: true,
    });
  };

  closeModalConfirm = async () => {
    this.setState({
      modalConfirm: false,
    });
  };

  closeModalResult = async () => {
    this.setState({
      modalResult: false,
    });
  };

  okModalConfirm = async () => {
    if (this.state.warehouseCode === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Pilih Gudang",
      });
      return;
    }

    await this.promisedSetState({
      saveProcessing: true,
    });

    try {
      await stockOtodisService
        .saveStockWisesa({
          dealer_code: this.state.dealerCode,
          warehouse_code: this.state.warehouseCode,
          brand_name: "Honda",
          data: this.state.dataDdms,
        })
        .then(async (dataInsert) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Data berhasil diinput. ",
          });

          await this.cancelProcess();
          await this.promisedSetState({
            listResult: dataInsert?.data.data_processed,
            modalResult: false,
            saveProcessing: false,
            modalConfirm: false,
          });
        });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        saveProcessing: false,
      });
    }
  };

  onWarehouseSourceChange = async (data: any) => {
    await this.promisedSetState({
      warehouseCode: data.value,
      warehouseName: data.children,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Import Stock Wisesa`}
          defaultSelectedKeys={["m-import-stock-wisesa"]}
          defaultOpenKeys={["sm-stock", "sm-sm-purchase"]}
        >
          <Tabs activeKey={this.state.tabKey.toString()}>
            <TabPane tab="Cari Data Stock Wisesa" disabled={true} key="1">
              <Result
                icon={<FormOutlined />}
                title="Pencarian data Stock Wisesa"
                extra={
                  <div>
                    <Row>
                      <Col xs={24} xl={6} className={`pad-10`} />
                      <Col xs={24} xl={12} className={`pad-10`}>
                        <Form.Item>
                          <i className={`small-text-grey`}>Tanggal Stock</i>
                          <DatePicker value={moment(this.state.startDate, "YYYY-MM-DD")} onChange={(event) => this.onchangeStartDate(event)} format={"YYYY-MM-DD"} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6} className={`pad-10`} />
                    </Row>

                    <br />
                    <Button onClick={this.fetchDataDdms} loading={this.state.fetchDdms} type="primary" icon={<SearchOutlined />}>
                      Cari Stock
                    </Button>
                  </div>
                }
              />
            </TabPane>
            <TabPane tab="Simpan Data Stock" disabled={true} key="2">
              <div>
                <Tooltip title="Batalkan Proses Simpan">
                  <Button shape="circle" icon={<LeftOutlined />} onClick={this.cancelProcess} />
                </Tooltip>

                <Button type={"primary"} style={{ marginLeft: 15 }} icon={<SaveOutlined />} onClick={this.onSaveData}>
                  Simpan Data
                </Button>
              </div>
              <br />
              <br />

              <Col xs={24} xl={8}>
                <div className={`mid-pad-10`} style={{}}>
                  <Form.Item>
                    <WarehouseSelect onWarehouseChangeProps={this.onWarehouseSourceChange} dealerCode={this.state.dealerCode} value={this.state.warehouseCode} />
                  </Form.Item>
                </div>
              </Col>

              <Table
                rowKey={"vehicle_engine_number"}
                size={"small"}
                scroll={{ x: "calc(500px + 50%)" }}
                loading={this.state.fetchDdms}
                columns={this.tableColumn}
                dataSource={this.state.dataDdms}
                pagination={{ pageSize: 10000 }}
              />
            </TabPane>
          </Tabs>

          <Modal visible={this.state.finalLoadingModal} closeIcon={true} footer={null}>
            <div style={{ textAlign: "center", padding: 20, minHeight: 100 }}>
              <Spin style={{ marginTop: 20 }} size={"large"} tip="Processing..." />
            </div>

            <div style={{ textAlign: "center", padding: 20 }}>
              Proses pengambilan data ke Daya Wisesa <br />
              Mohon menunggu beberapa saat.
            </div>
          </Modal>

          <Modal
            visible={this.state.modalConfirm}
            title="Konfirmasi Simpan"
            closeIcon={true}
            footer={[
              <Button key="1" type="primary" loading={this.state.saveProcessing} onClick={this.okModalConfirm}>
                Simpan
              </Button>,
              <Button key="2" loading={this.state.saveProcessing} onClick={this.closeModalConfirm}>
                Cancel
              </Button>,
            ]}
          >
            <Form layout={"vertical"}>Anda Yakin akan menyimpan data?</Form>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(DdmsInvoice), 19);
